import env from "@configs/env";

export function resolveMediaUrl(rawUrl) {
  if (!rawUrl) return "";
  if (rawUrl.startsWith("http://") || rawUrl.startsWith("https://"))
    return rawUrl;
  try {
    const origin = new URL(
      process.env.REACT_APP_API_BASE_URL || window.location.origin,
    ).origin;
    return `${origin}${rawUrl.startsWith("/") ? "" : "/"}${rawUrl}`;
  } catch (error) {
    return rawUrl;
  }
}

export function inferMediaType(url = "") {
  const clean = (url || "").split("?")[0].toLowerCase();
  if (/\.(png|jpg|jpeg|gif|webp|bmp|svg)$/.test(clean)) return "image";
  if (/\.(mp4|mov|webm|mkv|avi)$/.test(clean)) return "video";
  if (/\.(mp3|wav|ogg|aac|m4a)$/.test(clean)) return "audio";
  return "";
}

export function resolveMediaKind(media = {}) {
  const rawType = String(media?.mediaType || "")
    .toLowerCase()
    .trim();
  const mimeType = String(media?.mimeType || "")
    .toLowerCase()
    .trim();
  if (
    rawType.startsWith("image") ||
    rawType === "img" ||
    mimeType.startsWith("image/")
  )
    return "image";
  if (rawType.startsWith("video") || mimeType.startsWith("video/"))
    return "video";
  if (
    rawType.startsWith("audio") ||
    rawType === "sound" ||
    rawType === "voice" ||
    rawType === "audio_file" ||
    mimeType.startsWith("audio/")
  ) {
    return "audio";
  }
  return inferMediaType(media?.url || "");
}
